import React from 'react';
import { cn } from '@/lib/utils';
import { Loader2 } from 'lucide-react';

const AppButton = ({
  children,
  className,
  variant = 'primary', // primary, secondary, danger, success, ghost
  size = 'md', // sm, md, lg
  icon: Icon,
  loading = false,
  disabled = false,
  type = 'button',
  onClick,
  ...props
}) => {
  const variantClass = `app-button-${variant}`;
  const sizeClass = `app-button-${size}`;

  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      className={cn(
        'app-button',
        variantClass,
        sizeClass,
        className
      )}
      {...props}
    >
      {loading ? (
        <Loader2 className="app-button-spinner" />
      ) : Icon && (
        <Icon className={cn("w-4 h-4", children ? "mr-1" : "")} />
      )}
      {children}
    </button>
  );
};

export default AppButton;
